<script lang="ts">
  import mobileTail from '$lib/assets/branding/roadmap-tail-mobile.png'

  import { images } from './RoadmapImages.ts'
  import RoadmapCard from './RoadmapCard.svelte'
</script>

<div class="mx-auto max-w-[1700px] overflow-x-clip md:hidden">
  <section class="relative flex h-[1800px] flex-col items-center min-[360px]:h-[1500px]">
    <img src={mobileTail} alt="tail" class="maskEffect relative left-0 top-[180px]" />
    <div class="absolute top-[150px] flex flex-col items-center self-center">
      <h1 class="bg-black font-cirka text-[56px]">Roadmap</h1>

      <ul class="relative mt-10 space-y-8">
        <RoadmapCard
          title="Testnet Launch"
          description="1554 CDPs opened and 1349 transactions completed."
          date="[  Jan, 2024  ]"
          iconStyles="scale-[0.25] top-[-20px]"
          completed
        />
        <RoadmapCard
          title="Token Sale Event"
          description="The largest token sale ever on Cardano."
          date="[  Jan, 2024  ]"
          iconStyles="scale-[0.25] top-[-20px]"
          completed
        />
        <RoadmapCard
          title="Audit Completion"
          description="Bringing security assurance for Butane users."
          date="[  Aug, 2024  ]"
          icon={images.auditIcon}
          iconStyles="top-[-15px] -right-6"
          descriptionStyles="w-[80%]"
          completed
        />
        <RoadmapCard
          title="Contract Release"
          description="A commitment to transparency and security."
          date="[  Nov, 2024  ]"
          descriptionStyles="w-[80%]"
          icon={images.openSourceIcon}
          iconStyles="-right-6 top-[-15px]"
          completed
        />
        <RoadmapCard
          title="Mainnet Launch"
          description="A new era of synthetic assets begins on Cardano."
          date="[  Feb 28, 2025  ]"
          icon={images.mainnetIcon}
          iconStyles="top-[-15px] -right-6"
          descriptionStyles="w-[80%]"
          completed
        />
        <RoadmapCard
          title="Decentralized Governance"
          description="Making Butane a more decentralized and open protocol."
          date="[  2025  ]"
          icon={images.governanceIcon}
          iconStyles="scale-[1.2] top-[-5px] -right-6"
          descriptionStyles="w-[95%]"
        />
      </ul>
    </div>
  </section>
</div>

<style lang="postcss">
  .maskEffect {
    -webkit-mask: linear-gradient(0deg, white 20%, white 90%, transparent);
    mask: linear-gradient(0deg, white 20%, white 90% transparent);
  }
</style>
